/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBook2 = createReactComponent("outline", "book-2", "IconBook2", [["path", { "d": "M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12z", "key": "svg-0" }], ["path", { "d": "M19 16h-12a2 2 0 0 0 -2 2", "key": "svg-1" }], ["path", { "d": "M9 8h6", "key": "svg-2" }]]);

export { IconBook2 as default };
//# sourceMappingURL=IconBook2.mjs.map
